import type { AreaDict } from '../messages'

// Navegação, layout e Configurações. pt-BR = textos atuais do app.
const common: AreaDict = {
  'pt-BR': {
    'nav.dashboard': 'Dashboard',
    'nav.accounts': 'Contas',
    'nav.transactions': 'Transações',
    'nav.cards': 'Cartões',
    'nav.recurring': 'Recorrentes',
    'nav.budget': 'Orçamento',
    'nav.networth': 'Patrimônio',
    'nav.reports': 'Relatórios',
    'nav.settings': 'Configurações',
    'app.signOut': 'Sair',
    'app.reorderMenu': 'Reordenar menu',
    'app.done': 'Concluir',
    'app.menu': 'Menu',
    'app.reorderHint': 'Arraste os itens para reordenar. Toque ✓ para concluir.',
    'common.loading': 'Carregando…',
    'common.cancel': 'Cancelar',
    'common.save': 'Salvar',
    'common.saving': 'Salvando…',
    'common.add': 'Adicionar',
    'common.remove': 'Remover',
    'common.edit': 'Editar',
    'common.delete': 'Excluir',
    'app.updateTitle': 'Nova versão disponível',
    'app.updateDesc': 'Atualize para carregar as novidades.',
    'app.updateAction': 'Atualizar',
    'app.noTenant': 'Sua conta ainda não está vinculada a nenhum tenant. Fale com o administrador.',
    'settings.profile': 'Perfil',
    'settings.categories': 'Categorias',
    'settings.tags': 'Tags',
    'settings.currency': 'Moeda',
    'settings.users': 'Usuários',
    'settings.platformUsers': 'Adm. usuários',
    'settings.title': 'Configurações',
    'settings.language': 'Idioma',
    'settings.languageHint': 'Idioma da interface do aplicativo.',
    'profile.name': 'Nome do perfil',
    'currency.enabledTitle': 'Moedas habilitadas',
    'currency.enabledHint':
      'As moedas que você usa nas contas e lançamentos. A principal (⭐) é aquela em que todos os saldos e totais são consolidados — trocar reconverte tudo pelas taxas históricas de cada data.',
    'currency.principal': 'Principal',
    'currency.makePrincipal': 'Tornar principal',
    'currency.disable': 'Desabilitar',
    'currency.inUse': 'Tem contas/lançamentos nesta moeda — não pode desabilitar',
    'currency.addTitle': 'Adicionar moeda',
    'currency.addPlaceholder': 'Adicionar moeda…',
    'currency.allEnabled': 'Todas já habilitadas',
    'currency.search': 'Buscar moeda…',
    'currency.reconverting': 'Reconvertendo…',
  },
  en: {
    'nav.dashboard': 'Dashboard',
    'nav.accounts': 'Accounts',
    'nav.transactions': 'Transactions',
    'nav.cards': 'Cards',
    'nav.recurring': 'Recurring',
    'nav.budget': 'Budget',
    'nav.networth': 'Net worth',
    'nav.reports': 'Reports',
    'nav.settings': 'Settings',
    'app.signOut': 'Sign out',
    'app.reorderMenu': 'Reorder menu',
    'app.done': 'Done',
    'app.menu': 'Menu',
    'app.reorderHint': 'Drag the items to reorder. Tap ✓ to finish.',
    'common.loading': 'Loading…',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.saving': 'Saving…',
    'common.add': 'Add',
    'common.remove': 'Remove',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'app.updateTitle': 'New version available',
    'app.updateDesc': 'Refresh to load the latest changes.',
    'app.updateAction': 'Refresh',
    'app.noTenant': 'Your account is not linked to any tenant yet. Contact the administrator.',
    'settings.profile': 'Profile',
    'settings.categories': 'Categories',
    'settings.tags': 'Tags',
    'settings.currency': 'Currency',
    'settings.users': 'Users',
    'settings.platformUsers': 'User admin',
    'settings.title': 'Settings',
    'settings.language': 'Language',
    'settings.languageHint': 'Language of the app interface.',
    'profile.name': 'Profile name',
    'currency.enabledTitle': 'Enabled currencies',
    'currency.enabledHint':
      'The currencies you use in accounts and entries. The main one (⭐) is where all balances and totals are consolidated — changing it reconverts everything using each date’s historical rates.',
    'currency.principal': 'Main',
    'currency.makePrincipal': 'Make main',
    'currency.disable': 'Disable',
    'currency.inUse': 'There are accounts/entries in this currency — cannot disable',
    'currency.addTitle': 'Add currency',
    'currency.addPlaceholder': 'Add currency…',
    'currency.allEnabled': 'All already enabled',
    'currency.search': 'Search currency…',
    'currency.reconverting': 'Reconverting…',
  },
  es: {
    'nav.dashboard': 'Panel',
    'nav.accounts': 'Cuentas',
    'nav.transactions': 'Transacciones',
    'nav.cards': 'Tarjetas',
    'nav.recurring': 'Recurrentes',
    'nav.budget': 'Presupuesto',
    'nav.networth': 'Patrimonio',
    'nav.reports': 'Informes',
    'nav.settings': 'Configuración',
    'app.signOut': 'Salir',
    'app.reorderMenu': 'Reordenar menú',
    'app.done': 'Listo',
    'app.menu': 'Menú',
    'app.reorderHint': 'Arrastra los elementos para reordenar. Toca ✓ para terminar.',
    'common.loading': 'Cargando…',
    'common.cancel': 'Cancelar',
    'common.save': 'Guardar',
    'common.saving': 'Guardando…',
    'common.add': 'Agregar',
    'common.remove': 'Quitar',
    'common.edit': 'Editar',
    'common.delete': 'Eliminar',
    'app.updateTitle': 'Nueva versión disponible',
    'app.updateDesc': 'Actualiza para cargar las novedades.',
    'app.updateAction': 'Actualizar',
    'app.noTenant': 'Tu cuenta aún no está vinculada a ningún tenant. Habla con el administrador.',
    'settings.profile': 'Perfil',
    'settings.categories': 'Categorías',
    'settings.tags': 'Etiquetas',
    'settings.currency': 'Moneda',
    'settings.users': 'Usuarios',
    'settings.platformUsers': 'Adm. usuarios',
    'settings.title': 'Configuración',
    'settings.language': 'Idioma',
    'settings.languageHint': 'Idioma de la interfaz de la aplicación.',
    'profile.name': 'Nombre del perfil',
    'currency.enabledTitle': 'Monedas habilitadas',
    'currency.enabledHint':
      'Las monedas que usas en cuentas y movimientos. La principal (⭐) es en la que se consolidan todos los saldos y totales — cambiarla reconvierte todo con las tasas históricas de cada fecha.',
    'currency.principal': 'Principal',
    'currency.makePrincipal': 'Hacer principal',
    'currency.disable': 'Deshabilitar',
    'currency.inUse': 'Hay cuentas/movimientos en esta moneda — no se puede deshabilitar',
    'currency.addTitle': 'Agregar moneda',
    'currency.addPlaceholder': 'Agregar moneda…',
    'currency.allEnabled': 'Todas ya habilitadas',
    'currency.search': 'Buscar moneda…',
    'currency.reconverting': 'Reconvirtiendo…',
  },
}

export default common
